import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class ButtonsMagnet {
    static init() {
        this.buttons = document.querySelectorAll(".btn-magnet");

        if (this.buttons.length === 0) {
            return;
        }

        if (ScrollTrigger.isTouch !== 1) {
            document.addEventListener("mousemove", e => {
                this.initMagnets(e);
            });
        }
    }

    static initMagnets(e){
        this.cursorPosition = {
            left: e.clientX,
            top: e.clientY
        };

        this.buttons.forEach((single) => {
            const triggerDistance = single.getBoundingClientRect().width * 2;

            // Limitation maximale de déplacement (par exemple, 20px)
            const limited = single.dataset.limited;

            const targetPosition = {
                left:
                    single.getBoundingClientRect().left +
                    single.getBoundingClientRect().width / 2,
                top:
                    single.getBoundingClientRect().top +
                    single.getBoundingClientRect().height / 2
            };

            const distance = {
                x: targetPosition.left - this.cursorPosition.left,
                y: targetPosition.top - this.cursorPosition.top
            };

            const angle = Math.atan2(distance.x, distance.y);
            const hypotenuse = Math.sqrt(
                distance.x * distance.x + distance.y * distance.y
            );

            const moveElement = {
                x: gsap.quickTo(single, "x", {duration: 0.5, ease: "power2.out"}),
                y: gsap.quickTo(single, "y", {duration: 0.5, ease: "power2.out"})
            };

            if (hypotenuse < triggerDistance) {
                if (limited) {
                    moveElement.x(-((Math.sin(angle) * hypotenuse) / 2) / 10);
                    moveElement.y(-((Math.cos(angle) * hypotenuse) / 2) / 10);
                } else {
                    moveElement.x(-((Math.sin(angle) * hypotenuse) / 2) / 2);
                    moveElement.y(-((Math.cos(angle) * hypotenuse) / 2) / 2);
                }
            } else {
                moveElement.x(0);
                moveElement.y(0);
            }
        });
    }
}